// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/groupIcons.template file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const SubscriptionAbo = svgLazyLoader('cardsAndSubscriptions/subscription_abo')
const SubscriptionCard = svgLazyLoader('cardsAndSubscriptions/subscription_card')
const SubscriptionTickets = svgLazyLoader('cardsAndSubscriptions/subscription_tickets')
const SubscriptionTicketsOnalternative = svgLazyLoader('cardsAndSubscriptions/subscription_tickets_onalternative')

const ALL_CARDS_AND_SUBSCRIPTIONS_ICONS = [
  'subscription_abo',
  'subscription_card',
  'subscription_tickets',
  'subscription_tickets_onalternative',
] as const
export type CardsAndSubscriptionsIcon = (typeof ALL_CARDS_AND_SUBSCRIPTIONS_ICONS)[number]

const ICONS: LazyIconsGroup<CardsAndSubscriptionsIcon> = {
  subscription_abo: SubscriptionAbo,
  subscription_card: SubscriptionCard,
  subscription_tickets: SubscriptionTickets,
  subscription_tickets_onalternative: SubscriptionTicketsOnalternative,
}

export const isCardsAndSubscriptionsIcon = (
  cardsAndSubscriptionsKey: string,
): cardsAndSubscriptionsKey is CardsAndSubscriptionsIcon =>
  ALL_CARDS_AND_SUBSCRIPTIONS_ICONS.includes(cardsAndSubscriptionsKey as CardsAndSubscriptionsIcon)

export const getCardsAndSubscriptionsIcon = (cardsAndSubscriptionsKey: CardsAndSubscriptionsIcon): LazyIcon =>
  ICONS[cardsAndSubscriptionsKey]

export const getCardsAndSubscriptionsIcons = (): LazyIconsGroup<CardsAndSubscriptionsIcon> => ICONS
